// extracted by mini-css-extract-plugin
export default {"cardContainer":"styles_cardContainer__3Bdlg","titleDescContainer":"styles_titleDescContainer__3uJDL"};